/**
 * Keeps Google Maps embeds out of the DOM until the visitor gave marketing consent
 * in the cookie banner. Without this, the embed loads Google resources on page load (BAS-5908).
 * Without consent a placeholder is shown, which opens the cookie settings. When the visitor
 * withdraws consent later, the map is removed again.
 */
class GoogleMapsConsent extends HTMLElement {
    connectedCallback() {
        this.placeholder = this.querySelector('.google-maps-consent__placeholder');
        this.template = this.querySelector('template');
        this.onConsentCollected = event => this.toggleMap(event.detail.marketingAllowed);

        this.querySelector('.google-maps-consent__settings')?.addEventListener('click', () => {
            window.privacyBanner?.showPreferences?.();
        });

        document.addEventListener('visitorConsentCollected', this.onConsentCollected);

        if (window.Shopify?.customerPrivacy?.marketingAllowed?.()) {
            this.toggleMap(true);
            return;
        }

        window.Shopify?.loadFeatures([
            {
                name: 'consent-tracking-api',
                version: '0.1',
                onLoad: errors => {
                    if (errors) {
                        console.error(errors);
                        return;
                    }

                    this.toggleMap(window.Shopify?.customerPrivacy?.marketingAllowed());
                },
            },
        ]);
    }

    disconnectedCallback() {
        document.removeEventListener('visitorConsentCollected', this.onConsentCollected);
    }

    toggleMap(allowed) {
        if (allowed && !this.map) {
            this.map = document.createElement('div');
            this.map.appendChild(this.template.content.cloneNode(true));
            this.appendChild(this.map);
        }

        if (!allowed && this.map) {
            this.map.remove();
            this.map = null;
        }

        this.placeholder.hidden = !!allowed;
    }
}

if (!customElements.get('google-maps-consent')) {
    customElements.define('google-maps-consent', GoogleMapsConsent);
}
